import React from 'react';
import { Box, Typography, useTheme } from '@mui/material';
import { getInitials } from './lineupUtils';

const Pitch = ({ activeFormation, playersOnPitch, availablePlayers, isLocked, setSelectedPosForModal }) => {
    const theme = useTheme();
    if (!activeFormation) return null;

    return (
        <Box sx={{
            position: 'relative',
            width: '100%',
            height: 550,
            background: 'linear-gradient(180deg, #1a2e1a 0%, #0d1a0d 100%)',
            border: '1px solid',
            borderColor: 'rgba(190, 242, 100, 0.2)',
            borderRadius: 8,
            overflow: 'hidden',
            boxShadow: '0 20px 50px rgba(0,0,0,0.5)',
            mb: 4,
            '&::after': {
                content: '""',
                position: 'absolute',
                top: 0, left: 0, right: 0, bottom: 0,
                backgroundImage: 'radial-gradient(rgba(190, 242, 100, 0.05) 1px, transparent 1px)',
                backgroundSize: '30px 30px',
                pointerEvents: 'none'
            }
        }}>
            {/* Feldmarkierungen */}
            <Box sx={{ position: 'absolute', top: '50%', left: 0, right: 0, height: '1px', bgcolor: 'rgba(190, 242, 100, 0.15)', transform: 'translateY(-50%)' }} />
            <Box sx={{ 
                position: 'absolute', top: '50%', left: '50%', width: 140, height: 140, 
                borderRadius: '50%', border: '1px solid rgba(190, 242, 100, 0.15)', 
                transform: 'translate(-50%, -50%)',
                '&::after': {
                    content: '""',
                    position: 'absolute', top: '50%', left: '50%', width: 4, height: 4, 
                    bgcolor: 'rgba(190, 242, 100, 0.3)', borderRadius: '50%',
                    transform: 'translate(-50%, -50%)'
                }
            }} />
            
            {/* Strafräume */}
            <Box sx={{ position: 'absolute', top: -1, left: '50%', width: 260, height: 110, border: '1px solid rgba(190, 242, 100, 0.15)', transform: 'translateX(-50%)', borderTop: 'none', borderRadius: '0 0 12px 12px' }} />
            <Box sx={{ position: 'absolute', bottom: -1, left: '50%', width: 260, height: 110, border: '1px solid rgba(190, 242, 100, 0.15)', transform: 'translateX(-50%)', borderBottom: 'none', borderRadius: '12px 12px 0 0' }} />

            {/* Positionen */}
            {activeFormation.positionen.map(pos => {
                const currentVal = playersOnPitch[pos.id] ?? '';
                const initials = getInitials(currentVal, availablePlayers);
                const hasPlayer = !!currentVal;

                return (
                    <Box
                        key={pos.id}
                        sx={{
                            position: 'absolute',
                            left: `${pos.pos_x}%`,
                            bottom: `${pos.pos_y}%`,
                            transform: 'translate(-50%, 50%)',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            zIndex: 10,
                            cursor: isLocked ? 'default' : 'pointer',
                            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                            '&:hover': { 
                                transform: isLocked ? 'translate(-50%, 50%)' : 'translate(-50%, 50%) scale(1.15)',
                                zIndex: 15
                            }
                        }}
                        onClick={() => !isLocked && setSelectedPosForModal(pos)}
                    >
                        <Box sx={{
                            width: 54,
                            height: 54,
                            bgcolor: hasPlayer ? 'primary.main' : 'rgba(255,255,255,0.03)',
                            backdropFilter: 'blur(10px)',
                            borderRadius: '50%',
                            color: hasPlayer ? '#000' : 'rgba(255,255,255,0.4)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px solid',
                            borderColor: hasPlayer ? 'primary.main' : 'rgba(255,255,255,0.1)',
                            boxShadow: hasPlayer ? `0 0 20px ${theme.palette.primary.main}44` : 'none',
                            fontWeight: 900,
                            fontSize: initials ? '1rem' : '0.8rem',
                            fontFamily: 'Fira Code, monospace',
                            transition: 'all 0.3s ease'
                        }}>
                            {initials || pos.pos_short_name || pos.pos_name.substring(0, 2).toUpperCase()}
                        </Box>

                        <Box sx={{
                            mt: 1,
                            px: 1.5,
                            py: 0.3,
                            borderRadius: 2,
                            bgcolor: hasPlayer ? 'rgba(190, 242, 100, 0.1)' : 'rgba(0,0,0,0.3)',
                            border: '1px solid',
                            borderColor: hasPlayer ? 'primary.main' : 'transparent',
                            backdropFilter: 'blur(5px)',
                            transition: 'all 0.3s ease'
                        }}>
                            <Typography sx={{
                                color: hasPlayer ? 'primary.main' : 'rgba(255,255,255,0.5)',
                                fontWeight: 900,
                                fontSize: '0.65rem',
                                textTransform: 'uppercase',
                                letterSpacing: '0.05em'
                            }}>
                                {pos.pos_name}
                            </Typography>
                        </Box>
                    </Box>
                );
            })}
        </Box>
    );
};

export default Pitch;
